lmApp.service('SubscriptionResource', ['$resource', function ($resource) {
  return $resource('/sdp/v2/subscriptions',
    null,
    {
      get: {
        url: '/discovery:80/sdp/v2/subscriptions?$expand=plan,subscriber',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      cancelSubscription: {
        url: '/discovery:80/sdp/v2/billing-actions',
        method: 'POST',
        params: {},
        transformRequest: function (subscription) {
          return angular.toJson({
            type: "cancel-subscription",
            subscription: {id: subscription.id},
            plan: {id: subscription.plan.id},
            subscriber: {id: subscription.subscriber.id}
          });
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      create: {
        url: '/discovery:80/sdp/v2/subscriptions',
        method: 'POST',
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
      update: {
        url: '/discovery:80/sdp/v2/subscriptions/:id',
        method: 'PATCH',
        params: {
          id: '@id'
        },
        headers: {
          'X-Auth-Token': lh.common.config.get.bind(lh.common.config, 'authToken')
        }
      },
    }
  );
}]);